import { render, staticRenderFns } from "./ModalSupressaoAcrescimoAditivoApostila.vue?vue&type=template&id=3addfcad&scoped=true"
import script from "./ModalSupressaoAcrescimoAditivoApostila.vue?vue&type=script&lang=js"
export * from "./ModalSupressaoAcrescimoAditivoApostila.vue?vue&type=script&lang=js"
import style0 from "./ModalSupressaoAcrescimoAditivoApostila.vue?vue&type=style&index=0&id=3addfcad&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3addfcad",
  null
  
)

export default component.exports